<template>
    <b-container fluid>
        <LoanLOIPrint :ApplicationID="ApplicationID" :Loantype="1" :UserID="UserID" ></LoanLOIPrint>
    </b-container>
    
</template>

<script>
import LoanLOIPrint from "@/components/RegistrationLoan/LoanLOIPrint";
export default {
    data(){
        return{
            LoanType:1,
            UserID:"00000000-0000-0000-0000-000000000000"
        }
    },
    components: { LoanLOIPrint },
    props:["ApplicationID", "LOINumber"],
    mounted(){
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/VerifyLoi.vue